// extracted by mini-css-extract-plugin
module.exports = {"previewWrapper":"LabelPreview_previewWrapper__xwwdG","previewImage":"LabelPreview_previewImage__HggKx"};